import { Component } from '@angular/core';
import {
  RouterLink,
  RouterLinkActive,
  RouterModule,
  RouterOutlet,
} from '@angular/router';
import { SubMenuComponent } from './sub-menu/sub-menu.component';
import { AdminSidebarComponent } from './admin-sidebar/admin-sidebar.component';

@Component({
    selector: 'app-left-menu',
    imports: [
        SubMenuComponent,
        RouterModule,
    ],
    templateUrl: './left-menu.component.html',
    styleUrls: ['./left-menu.component.css']
})
export class LeftMenuComponent {
  ngAfterViewInit() {
    const el = document.querySelector('#sidebar');
    if (el && (window as any).Drawer) {
      new (window as any).Drawer(el);
    }
    if (el) {
      el.addEventListener('kt.drawer.after.hide', () => {
        el.classList.remove('active');
      });
    }
  }
}
